module.exports = __webpack_public_path__ + "img/germany-transport-accidents-male.e956edd6.png";